const Team=[
    {
        id:1,
        title:"Lamiya Chowdhury",
        secondtitle:"Chairman",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/8528741/pexels-photo-8528741.jpeg?auto=compress&cs=tinysrgb&w=600"
    },

    {
        id:2,
        title:"MD Shahidul Islam",
        secondtitle:"CEO",

        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/3783577/pexels-photo-3783577.jpeg?auto=compress&cs=tinysrgb&w=600"
    },

    {
        id:3,
        title:"Afzal Aslam ",
        secondtitle:"Managing Director",

        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/1586996/pexels-photo-1586996.jpeg?auto=compress&cs=tinysrgb&w=600"
    },

    {
        id:4,
        title:"Rafique Rahman",
        secondtitle:"Managing Director",

        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/3771807/pexels-photo-3771807.jpeg?auto=compress&cs=tinysrgb&w=600"
    },

    {
        id:5,
        title:"Jalal Sarkar",
        secondtitle:"Managing Director",

        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/5668885/pexels-photo-5668885.jpeg?auto=compress&cs=tinysrgb&w=600"
    },


    {
        id:6,
        title:"Sekh Mehidi",
        secondtitle:"Managing Director",

        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/864994/pexels-photo-864994.jpeg?auto=compress&cs=tinysrgb&w=600"
    },
  
   

   

]

export default Team;